import { EVENTS } from '../../../bus/events.const';
import { COMPONENTS } from '../../../components/components.registry';
import { ResultsSuggestionsConfig } from '../../../models';

export const DEFAULT_RESULTS_SUGGESTIONS_CONFIG: ResultsSuggestionsConfig = {
  components: {
    container: COMPONENTS.PURE.Suggestions,
    item: COMPONENTS.PURE.ResultSuggestion,
    result: COMPONENTS.SMART.ConfigurableResult
  },
  clickEvents: {
    click: EVENTS.ResultClicked,
    rightClick: EVENTS.ResultRightClicked
  },
  size: 8
};
